// extracted by mini-css-extract-plugin
export default {"recommendedArticlesContainer":"RecommendationsTwoByTwoLayout_recommendedArticlesContainer__+ER6d","sectionSpacing":"RecommendationsTwoByTwoLayout_sectionSpacing__HxXW5"};